import { useState } from 'react';
import { useParams } from 'react-router';

import { useQuery } from 'hooks/useQuery/useQuery';
import { QueryKeyEnum } from 'core/global.enum';
import {
  QueryKeyLocalStorageEnum,
  UserPermissionsHistoryQueryKeysEnum,
  WantedHistoryQueryKeysEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { useSavedPagination } from 'hooks/useSavedPagination/useSavedPagination';
import { fetchUserPermissionsHistory } from 'api/userPermissions/userPermissions';

import { UserPermissionsHistory } from './UserPermissionsHistory';

export const UserPermissionsHistoryContainer = () => {
  const { id } = useParams();

  const {
    storedQueries: { userPermissionsHistory: userPermissionsHistoryQuery },
    setQuery,
  } = useLocaleStoreQuery();

  const [userSearchQuery, setUserSearchQuery] = useState(userPermissionsHistoryQuery?.query?.label || '');

  const { page, rowsPerPage, setPage, setRowsPerPage, setPaginationCount, storedQueryWithoutPagination } =
    useSavedPagination({
      queryKey: QueryKeyLocalStorageEnum.USER_PERMISSIONS_HISTORY,
      resetPaginationDependencyArray: [userSearchQuery],
    });

  const { data: historyResponse, isLoading } = useQuery(
    [QueryKeyEnum.USER_PERMISSIONS_HISTORY, storedQueryWithoutPagination, rowsPerPage, page, userSearchQuery],
    () => fetchUserPermissionsHistory(id),
    {
      args: {
        ...storedQueryWithoutPagination,
        [UserPermissionsHistoryQueryKeysEnum.QUERY]: userPermissionsHistoryQuery.query?.value,
        [WantedHistoryQueryKeysEnum.LIMIT]: rowsPerPage,
        [WantedHistoryQueryKeysEnum.OFFSET]: rowsPerPage * page,
      },
      onSuccess: (response) => {
        setPaginationCount(response.count);
      },
    },
  );

  const onClearHistoryQuery = () => {
    setQuery(QueryKeyLocalStorageEnum.USER_PERMISSIONS_HISTORY, {
      page,
      rowsPerPage,
    });
    setUserSearchQuery('');
  };

  return (
    <UserPermissionsHistory
      historyResponse={historyResponse}
      isLoading={isLoading}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      userSearchQuery={userSearchQuery}
      setUserSearchQuery={setUserSearchQuery}
      onClearHistoryQuery={onClearHistoryQuery}
    />
  );
};
